import { useEffect, useState } from "react";
import { authFetch } from "../lib/auth-fetch";
import type { ConnectedPlatforms } from "../types/platforms.types";

export function useConnectedPlatforms(): ConnectedPlatforms {
	const [platforms, setPlatforms] = useState<ConnectedPlatforms>({ bluesky: false, blueskyHandle: null });

	useEffect(() => {
		authFetch("/api/settings/social")
			.then((r) => r.json())
			.then((data) => setPlatforms({
				bluesky: !!data.bluesky,
				blueskyHandle: data.bluesky?.handle ?? null,
			}))
			.catch(() => {});
	}, []);

	return platforms;
}
